import React, { Component } from "react";

import SliderMarker from "./marker";


export default class Slider extends Component {
	marker_label_ref = [null, null];
	minmax_label_ref = [null, null];
	markersDown = [false, false];
	containerRef = null;
	clickOffset = 0;
	sliderWidth = 0;
	markerRef = null;
	markerWidth = 0;
	markerTop = 0;
	minRangeWidth = 0;
	sliderY = 0;

	static defaultProps = {
		className: "",
		min: 0,
		max: 100,
		value: 0,
		minRange: 0,
		allowFloat: false,
		floatPrecision: 2,
		showMinmax: false,
		showValue: false,
		onChange: _ => {},
		renderValue: value => {
			return value;
		}
	};

	constructor(props) {
		super(props);

		let v1 = undefined;
		let v2 = undefined;
		if (props.value instanceof Array) {
			if (props.value.length) {
				v1 = props.value[0];
				if (props.value.length === 2) v2 = props.value[1];
			}
		} else v1 = props.value;

		const values = [];
		if (v1 !== undefined) values.push(v1);
		if (v2 !== undefined) values.push(v2);

		this.state = {
			value: values,
			positions: [0, 0],
			offsetX: 0
		};
	}

	componentDidMount() {
		document.addEventListener("mouseup", this.onDocumentMouseUp);
		document.addEventListener("mousemove", this.onDocumentMouseMove);
		window.addEventListener("resize", this.onWindowResize);
	}

	componentWillUnmount() {
		document.removeEventListener("mouseup", this.onDocumentMouseUp);
		document.removeEventListener("mousemove", this.onDocumentMouseMove);
		window.removeEventListener("resize", this.onWindowResize);
	}

	onLayout = (ref) => {
		this.containerRef = ref;
		this.onWindowResize();
	};

	markerOnLayout = (ref) => {
		if (ref) {
			const rect = ref.getBoundingClientRect();
			this.markerRef = ref;
			this.markerWidth = rect.width;
		}
	};

	getMakerPosition = i => {
		if (this.state.value[i] !== undefined) return ((this.state.value[i] - this.props.min) * this.sliderWidth) / (this.props.max - this.props.min) - this.markerWidth / 2;
		return 0;
	};

	getMarkerValue = i => {
		if (this.state.positions[i] !== undefined) return this.props.min + (this.state.positions[i] * (this.props.max - this.props.min)) / this.sliderWidth;
		return 0;
	};

	onWindowResize = () => {
		if (this.containerRef && this.markerRef) {
			const rect = this.containerRef.getBoundingClientRect();
			const markerRect = this.markerRef.getBoundingClientRect();
			const offsetX = rect.left;
			this.sliderWidth = rect.width;
			this.sliderY = rect.y;
			this.minRangeWidth = (this.props.minRange * this.sliderWidth) / (this.props.max - this.props.min);
			this.markerTop = markerRect.top - rect.top - this.markerWidth - 2;
			this.setState({
				offsetX: offsetX,
				positions: [this.getMakerPosition(0), this.state.value[1] !== null ? this.getMakerPosition(1) : 0]
			});
		}
	};

	onMouseDown = (i, e) => {
		this.markersDown[i] = true;
		this.clickOffset = e.pageX - (this.state.offsetX + this.state.positions[i]);
	};

	onMouseUp = i => {
		this.markersDown[i] = false;
		this.clickOffset = 0;
	};

	onDocumentMouseUp = () => {
		this.markersDown = [false, false];
		this.clickOffset = 0;
	};

	onDocumentMouseMove = e => {
		if (this.markersDown[0] || this.markersDown[1]) {
			const i = this.markersDown[0] ? 0 : 1;
			let x = e.clientX - this.state.offsetX - this.clickOffset;

			if (x < 0) x = 0;
			else if (x > this.sliderWidth) x = this.sliderWidth;

			if (this.markersDown[0] && this.state.value[1] !== undefined && x + this.minRangeWidth > this.state.positions[1]) 
				x = this.state.positions[1] - this.minRangeWidth;
			else if (this.markersDown[1] && x - this.minRangeWidth < this.state.positions[0]) 
				x = this.state.positions[0] + this.minRangeWidth;

			const pos = this.state.positions;
			const val = this.state.value;
			pos[i] = x;
			val[i] = this.getMarkerValue(i);
			if (!this.props.allowFloat) val[i] = Math.round(val[i] || 0);
			else val[i] = parseFloat((val[i] || 0).toFixed(this.props.floatPrecision));

			this.setState(
				{
					value: val,
					positions: pos
				},
				() => {
					let v = this.state.value;
					if (this.state.value.length === 1) v = this.state.value[0] || 0;
					this.props.onChange(v);
				}
			);

			if (e.stopPropagation) e.stopPropagation();
			if (e.preventDefault) e.preventDefault();

			e.cancelBubble = true;
			e.returnValue = false;
		}
	};

	getMarkerLabelPosition = i => {
		let labelWidth = 0;

		if (this.marker_label_ref[i]) {
			const rect = this.marker_label_ref[i].getBoundingClientRect();
			labelWidth = rect.width;
		}

		return this.state.positions[i] - labelWidth / 2;
	};

	getMinMaxLabelPosition = i => {
		let labelWidth = 0;

		if (this.minmax_label_ref[i]) {
			const rect = this.minmax_label_ref[i].getBoundingClientRect();
			labelWidth = rect.width;
		}

		return -labelWidth / 2;
	};

	render() {
		const { min, max, value, minRange, allowFloat, floatPrecision, showMinmax, showValue, onChange, renderValue, className, ...props } = this.props;

		return (
			<div className={"slider-container " + (className ? className : "")} ref={this.onLayout} {...props}>
				<div className="slider-back-bar"> </div>

				<div
					className="slider-active-bar"
					style={{
						left: this.state.value[1] ? this.state.positions[0] : 0,
						right: this.sliderWidth - (this.state.value[1] ? this.state.positions[1] : this.state.positions[0])
					}}
				>
					&nbsp;
				</div>

				{showValue && (
					<div
						className={"slider-marker-value"}
						ref={ref => {
							this.marker_label_ref[0] = ref;
						}}
						style={{
							top: this.markerTop,
							left: this.getMarkerLabelPosition(0)
						}}
					>
						{renderValue(this.state.value[0])}
					</div>
				)}

				{showMinmax && (
					<div
						className={"slider-minmax-value min"}
						ref={ref => {
							this.minmax_label_ref[0] = ref;
						}}
						style={{
							left: this.getMinMaxLabelPosition(0)
						}}
					>
						{renderValue(this.props.min)}
					</div>
				)}
				{showMinmax && (
					<div
						className={"slider-minmax-value max"}
						ref={ref => {
							this.minmax_label_ref[1] = ref;
						}}
						style={{
							right: this.getMinMaxLabelPosition(1)
						}}
					>
						{renderValue(this.props.max)}
					</div>
				)}

				<SliderMarker
					value={this.state.value[0]}
					style={{ left: this.state.positions[0] - this.markerWidth / 2 }}
					onMouseDown={e => {
						this.onMouseDown(0, e);
					}}
					onMouseUp={() => {
						this.onMouseUp(0);
					}}
					onLayout={this.markerOnLayout}
				/>

				{value instanceof Array && (
					<SliderMarker
						value={this.state.value[1]}
						style={{ left: this.state.positions[1] - this.markerWidth / 2 }}
						onMouseDown={e => {
							this.onMouseDown(1, e);
						}}
						onMouseUp={() => {
							this.onMouseUp(1);
						}}
					/>
				)}

				{value instanceof Array && showValue && (
					<div
						className={"slider-marker-value"}
						ref={ref => {
							this.marker_label_ref[1] = ref;
						}}
						style={{
							top: this.markerTop,
							left: this.getMarkerLabelPosition(1)
						}}
					>
						{renderValue(this.state.value[1])}
					</div>
				)}
			</div>
		);
	}
}



// WEBPACK FOOTER //
// ./src/components/Slider/index.js